import { Injectable } from '@angular/core';
import { Router, NavigationStart, NavigationEnd, NavigationCancel, NavigationError } from '@angular/router';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProgressBarService {
  private loading: boolean = false;
  private progress$: Subject<number> = new Subject<number>();
  constructor(private router: Router) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.loading = true;
        this.progress$.next(10);
      }
      else if (event instanceof NavigationEnd || event instanceof NavigationCancel || event instanceof NavigationError) {
        this.loading = false;
        this.progress$.next(100);
      }
    });
  }
  public getLoading(): boolean {
    return this.loading;
  }

  public getProgress(): Observable<number> {
    return this.progress$.asObservable();
  }
}
